import React from "react";

//Component ==========
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardContent from '@material-ui/core/CardContent';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Autocomplete from "components/Autocomplete/Select.jsx";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

// import URL from "UrlServer"
// import { APIGet,APIPost } from "APIRequest"
// import * as Alert from "alertService"

//Question Component ==========    
import Button from "components/CustomButtons/Button.jsx"
import image from "assets/img/banner_2019.jpg";

import PlayArrowIcon from "@material-ui/icons/PlayArrow"

import withStyles from "@material-ui/core/styles/withStyles";

import wordingIntro from "configs/wordingIntro.jsx"

// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import ZaraTHImage from "assets/img/zara_th.png";
import ZaraENImage from "assets/img/zara_en.png";

// import LogoImage from "assets/img/nissan_logo.png"; 
import ExpiredImage from "assets/img/nissan_boy_expired.png";

const wording = {
  text_btn: {
    th: "เริ่มทำแบบสอบถาม",
    en: "Start the questionnaire",
  }
}
const styles = {
  ...sidebarStyle,
}
class thankyouPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      language: this.props.language,
    }
  }
  handleChangeSelect = name => value => {
    this.setState({
      [name]: value,
    });
  };
  render() {
    const { classes, customerData } = this.props;
    return (
      <div>
        <center>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div>
            {/* <img src={ExpiredImage} alt="expired-img" className="expired-img" /> */}
            <h3>แบบสอบถามคุณหมดอายุแล้ว</h3>
          </div>
        </center>
      </div>
    );
  }
}
export default withStyles(styles)(thankyouPage)